"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export default function LegacyScriptInitializer({ scripts = [] }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // 1) Optional cleanup from previous page
    if (window.main && typeof window.main.destroy === "function") {
      try {
        window.main.destroy();
      } catch {}
    }

    // 2) Remove previously injected legacy scripts
    document
      .querySelectorAll('script[data-legacy-script="true"]')
      .forEach((el) => el.remove());

    const versionKey = `${pathname}?${searchParams?.toString() || ""}`;
    // 3) Inject scripts in order; re-download each with ?v=versionKey
    let loadedCount = 0;
    const total = scripts.length;

    const onOneLoaded = () => {
      loadedCount += 1;
      if (loadedCount === total) {
        // When ALL scripts are loaded, re-initialize
        if (window.main && typeof window.main.init === "function") {
          try {
            window.main.init();
          } catch (e) {
            console.error("main.init error:", e);
          }
        }
      }
    };

    scripts.forEach((src, idx) => {
      const s = document.createElement("script");
      s.src = appendVersion(src);
      s.async = false; 
      s.defer = true;
      s.setAttribute("data-legacy-script", "true");
      s.onload = onOneLoaded;
      s.onerror = (e) => {
        console.error("Failed to load script:", s.src, e);
        onOneLoaded();
      };
      document.head.appendChild(s);
    });

    return () => {};
  }, [pathname, searchParams, scripts]);

  return null;
}

function appendVersion(url) {
  try {
    const u = new URL(
      url,
      typeof window !== "undefined"
        ? window.location.origin
        : "http://localhost"
    );
    return u.toString();
  } catch {
    return `${url}`;
  }
}
